<template>
<div>
    <section class="nav">
        <div class="nav-holder-div">
            <div class="nav-bar-div w-clearfix">
                <a href="#" class="brand w-nav-brand">
                    <img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="nav-logo">
                </a>

            </div>
        </div>
    </section>

    <!-- Loading State -->
    <div v-if="isLoading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- Error State -->
    <div v-if="hasError" class="error-section">
        <div class="error-message">{{ errorMessage }}</div>
        <button @click="loadUserQuizData" class="retry-button">Try Again</button>
    </div>

    <!-- Main Content - Only show when data is loaded -->
    <div v-if="!isLoading && !hasError && userMetabolics">
        <!-- Report Hero Section -->
        <section class="report-hero">
            <div class="reph_wrap">
                <div class="reph_maindiv">
                    <!-- Hero text elements with staggered animations -->
                    <div ref="heroText1" class="text-block-1374 scroll-animate" data-delay="0">
                        We believe in you {{ user?.first_name || 'there' }}!
                    </div>
                    <div ref="heroText2" class="text-block-1375 scroll-animate" data-delay="200">
                        This is the plan to get lean, feel better, and finally feel in control again.<br>
                    </div>
                    
                    <!-- Keep It Simple Section -->
                    <div ref="heroText3" class="report_segment-div scroll-animate" data-delay="400">
                        <div class="rep_segment-header">Keep It Simple — Build Habits That Stick</div>
                        <p class="rep_segment-sub">Most experts and big companies overcomplicate weight loss. This plan doesn't. It's one formula you'll lock in fast: Medication + Execution + Commitment. Once you start, it becomes routine. Habits form, energy returns, and the mental and physical burden of weight loss finally lifts.<br></p>
                    </div>
                    
                    <!-- GLP Section -->
                    <div ref="heroText4" class="report_segment-div scroll-animate" data-delay="600">
                        <div class="rep_segment-header">GLP: The Superpower You've Been Missing</div>
                        <p class="rep_segment-sub">GLP meds flip the script. They make eating smaller, healthier meals easy. They make fasting attainable. Hunger quiets down, cravings lose their grip, and suddenly the right choices don't feel like a battle.<br></p>
                    </div>
                    
                    <!-- TDEE Section -->
                    <div ref="heroText5" class="report_segment-div scroll-animate" data-delay="800">
                        <div class="rep_segment-header tdee">Maximize TDEE — The Real Fat-Burning Formula</div>
                        <p class="rep_segment-sub">Most people think weight loss comes mainly from workouts. The truth? Exercise is only a small slice of the pie. Your daily calorie burn (TDEE) comes from four main sources:<br></p>
                        
                        <!-- TDEE List -->
                        <ul role="list" class="tdee-list">
                            <li class="tdee-list-bullet">
                                <div class="text-block-1574">Exercise / Workouts (5-15%)</div>
                                <div class="text-block-1575">Lifting, cardio, classes - important, but not the main driver.</div>
                            </li>
                            <li class="tdee-list-bullet">
                                <div class="text-block-1574">Thermic Effect of Food (10-15%)</div>
                                <div class="text-block-1575">Calories and macros matter. Protein especially takes more energy to digest.</div>
                            </li>
                            <li class="tdee-list-bullet">
                                <div class="text-block-1574">Non-Exercise Activity (5-20%)</div>
                                <div class="text-block-1575">Steps, standing vs. sitting, even fidgeting—these small movements add up.</div>
                            </li>
                            <li class="tdee-list-bullet">
                                <div class="text-block-1574">Resting Metabolic Rate (50-70%)</div>
                                <div class="text-block-1575">The biggest factor. Sleep, hydration, lean body mass, body fat, stress, immune health, hormones, medication, age, and genetics.</div>
                            </li>
                        </ul>
                        
                        <!-- TDEE Chart -->
                        <div class="tedee-chart-div">
                            <div class="text-block-1576 hide">What is TDEE?</div>
                            <div class="tedee-graph-div">
                                <div class="tedee-left-div">
                                    <div class="text-block-1477">Where people <span class="hilite-span">*think</span> they burn calories</div>
                                    <img src="@/assets/images/TEDEE_DektopA-01.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/TEDEE_DektopA-01-p-500.webp 500w, @/assets/images/TEDEE_DektopA-01-p-800.webp 800w, @/assets/images/TEDEE_DektopA-01-p-1080.webp 1080w, @/assets/images/TEDEE_DektopA-01.webp 1698w" alt="" class="tedee-image-desk _1"><img src="@/assets/images/TEDEE_Mobile01-01.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/TEDEE_Mobile01-01-p-500.webp 500w, @/assets/images/TEDEE_Mobile01-01-p-800.webp 800w, @/assets/images/TEDEE_Mobile01-01-p-1080.webp 1080w, @/assets/images/TEDEE_Mobile01-01.webp 1698w" alt="" class="tedee-image-mobile">
                                </div>
                                <div class="tedee_divider"></div>
                                <div class="tedee-right">
                                    <div class="text-block-1477">Where people <span class="hilite-span">actually</span> burn calories</div>
                                    <img src="@/assets/images/TEDEE_Mobile02-01.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-500.webp 500w, @/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-800.webp 800w, @/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-1080.webp 1080w, @/assets/images/TEDEE_Mobile02-01.webp 1698w" alt="" class="tedee-image-desk">
                                    <img src="@/assets/images/TEDEE_Mobile02-01.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-500.webp 500w, @/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-800.webp 800w, @/assets/images/045f5a6d07780e4b5e5e176992427a01_TEDEE_Mobile02-01-p-1080.webp 1080w, @/assets/images/TEDEE_Mobile02-01.webp 1698w" alt="" class="tedee-image-mobile">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Biohacking Section -->
                    <div ref="biohackSection" class="report_segment-div biohack scroll-animate" data-delay="1000">
                        <div class="rep_segment-header biohack">Biohacking: The Accelerator</div>
                        <p class="rep_segment-sub">Biohacking means making small, targeted adjustments to improve how your body performs. Better sleep, stress control, hydration, recovery, and nutrition tweaks can all raise your metabolic rate. The result? Exercise feels easier, recovery is smoother, and results compound faster—with less effort.<br></p>
                    </div>
                    
                    <!-- Homework Section -->
                    <div class="report_segment-div homework">
                        <div ref="homeworkSection" class="homework-div scroll-animate" data-delay="1200">
                            <div class="rep_segment-header homework">Your Homework - Do This Now</div>
                            <ul role="list" class="homework-list">
                                <li class="hw-list-bullet">
                                    <div class="text-block-1574">Review your stats</div>
                                    <div class="hw_box-subs break">Look at your metabolic breakdown below to understand exactly what's driving your calorie burn and what needs to improve to hit your goals.</div>
                                </li>
                                <li class="hw-list-bullet">
                                    <div class="text-block-1574">Read the guide</div>
                                    <div class="hw_box-subs">Download the eBook, follow the system, and stick with the checklist.</div>
                                </li>
                                <li class="hw-list-bullet last">
                                    <div class="text-block-1574">Stay tuned</div>
                                    <div class="hw_box-subs">We'll be reaching out with more solutions to accelerate your progress. New features and strategies will be added regularly—not just for weight loss, but for your overall health optimization.</div>
                                </li>
                            </ul>
                        </div>
                        
                        <!-- Weight Summary and Metabolic Data Section -->
                        <div class="report_segment-div">
                            <div class="weight-summary">
                                <div class="weight-box">
                                    <div class="text-block-1386">Current Weight</div>
                                    <div class="text-block-1387">{{ userMetabolics.userInfo.currentWeight }}</div>
                                    <div class="text-block-1388">Pounds</div>
                                </div>
                                <div class="weight-box goal">
                                    <div class="text-block-1386">Goal Weight</div>
                                    <div class="text-block-1387">{{ userMetabolics.userInfo.goalWeight }}</div>
                                    <div class="text-block-1388">Pounds</div>
                                </div>
                            </div>

                            <!-- BMR Section with animation -->
                            <div ref="bmrSection" class="div-block-2038 scroll-animate" data-delay="100">
                                <div class="div-block-2039">
                                    <div class="small-box-header-highlight">Your Estimated Burn Rate</div>
                                    <div class="small-box-sub">Estimated Basal Metabolic Rate (BMR)</div>
                                    <div class="div-block-2040">
                                        <img src="@/assets/images/emoji-fire.webp" loading="lazy" sizes="(max-width: 512px) 100vw, 512px" srcset="@/assets/images/emoji-fire-p-500.webp 500w, @/assets/images/emoji-fire.webp 512w" alt="" class="image-588">
                                        <div class="text-block-1379">
                                            Approximately how much <strong>your body burns a day at rest.</strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="div-block-2041">
                                    <div class="text-block-1381">{{ formatNumber(userMetabolics.metabolics.bmr) }}</div>
                                    <div class="text-block-1382">Calories Per Day</div>
                                </div>
                            </div>

                            <!-- TDEE Section with animation -->
                            <div ref="tdeeSection" class="div-block-2038 scroll-animate" data-delay="200">
                                <div class="div-block-2039">
                                    <div class="small-box-header-highlight">Total Burn with Activity</div>
                                    <div class="small-box-sub">This was based on your answer of <strong>{{ userMetabolics.userInfo.activityLevel }}</strong></div>
                                    <div class="div-block-2040">
                                        <img src="@/assets/images/emoji_man-running.webp" loading="lazy" alt="" class="image-588">
                                        <div class="text-block-1379">Total calories consumed to stay at same weight</div>
                                    </div>
                                </div>
                                <div class="div-block-2041">
                                    <div class="text-block-1381">{{ formatNumber(userMetabolics.metabolics.tdee) }}</div>
                                    <div class="text-block-1382">Calories Per Day</div>
                                </div>
                            </div>

                            <!-- Calorie Deficit Calculator with animation -->
                            <div ref="deficitSection" class="div-block-2038 scroll-animate" data-delay="300">
                                <div class="div-block-2039">
                                    <div class="small-box-header-highlight">Calorie Deficit Calculator</div>
                                    <div class="small-box-sub">How many calories you need to melt fat. This may seem aggressive, but...let the GLP do the work.</div>

                                    <!-- Aggressive Plan (50% deficit) -->
                                    <div class="sumarry-bullets" v-if="userMetabolics.metabolics.deficits.aggressive">
                                        <div class="text-block-1384">
                                            Aggressive <strong>{{ userMetabolics.metabolics.deficits.aggressive.percentage }}% Caloric Reduction</strong>
                                        </div>
                                        <div>
                                            <div class="text-block-1385">
                                                {{ formatNumber(userMetabolics.metabolics.deficits.aggressive.dailyCalories) }}
                                            </div>
                                            <div class="text-block-1382">Calories Per Day</div>
                                        </div>
                                    </div>

                                    <!-- Accelerated Plan (40% deficit) -->
                                    <div class="sumarry-bullets" v-if="userMetabolics.metabolics.deficits.accelerated">
                                        <div class="text-block-1384">Accelerated <strong>{{ userMetabolics.metabolics.deficits.accelerated.percentage }}% Caloric Reduction</strong></div>
                                        <div>
                                            <div class="text-block-1385">{{ formatNumber(userMetabolics.metabolics.deficits.accelerated.dailyCalories) }}</div>
                                            <div class="text-block-1382">Calories Per Day</div>
                                        </div>
                                    </div>

                                    <!-- Sustainable Plan (30% deficit) -->
                                    <div class="sumarry-bullets bottom" v-if="userMetabolics.metabolics.deficits.sustainable">
                                        <div class="text-block-1384">Sustainable <strong>{{ userMetabolics.metabolics.deficits.sustainable.percentage }}% Caloric Reduction</strong></div>
                                        <div>
                                            <div class="text-block-1385">{{ formatNumber(userMetabolics.metabolics.deficits.sustainable.dailyCalories) }}</div>
                                            <div class="text-block-1382">Calories Per Day</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Weight Loss Projections with animation -->
                            <div ref="weightLossSection" class="rs_right comb scroll-animate" data-delay="400">
                                <div class="small-box-header-highlight">Estimated Weight Loss</div>
                                <div class="small-box-sub">How many calories you need to melt fat. This may seem aggressive, but...let the GLP do the work.</div>
                                <div class="sum-box-label">
                                    <div class="div-block-2045-copy">
                                        <div class="text-block-1389 color"><strong class="bold-text-39">Lbs per week</strong></div>
                                    </div>
                                    <div class="div-block-2046">
                                        <div class="text-block-1389-copy color"><strong class="bold-text-40">12-week sprint</strong></div>
                                    </div>
                                </div>

                                <!-- Aggressive Weight Loss -->
                                <div class="sumarry-bullets" v-if="userMetabolics.metabolics.weightLoss?.aggressive">
                                    <div class="text-block-1384 top">
                                        Aggressive <strong>{{ userMetabolics.metabolics.deficits.aggressive.percentage }}% Caloric Reduction</strong>
                                    </div>
                                    <div class="div-block-2045">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.aggressive.lbsPerWeek }}
                                        </div>
                                    </div>
                                    <div class="div-block-2046">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.aggressive.daysToGoal }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Accelerated Weight Loss -->
                                <div class="sumarry-bullets" v-if="userMetabolics.metabolics.weightLoss?.accelerated">
                                    <div class="text-block-1384 top">
                                        Accelerated <strong>{{ userMetabolics.metabolics.deficits.accelerated.percentage }}% Caloric Reduction</strong>
                                    </div>
                                    <div class="div-block-2047">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.accelerated.lbsPerWeek }}
                                        </div>
                                    </div>
                                    <div class="div-block-2048">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.accelerated.daysToGoal }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Sustainable Weight Loss -->
                                <div class="sumarry-bullets bottom" v-if="userMetabolics.metabolics.weightLoss?.sustainable">
                                    <div class="text-block-1384 top">
                                        Sustainable <strong>{{ userMetabolics.metabolics.deficits.sustainable.percentage }}% Caloric Reduction</strong>
                                    </div>
                                    <div class="div-block-2050">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.sustainable.lbsPerWeek }}
                                        </div>
                                    </div>
                                    <div class="div-block-2049">
                                        <div class="text-block-1385">
                                            {{ userMetabolics.metabolics.weightLoss.sustainable.daysToGoal }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Macros Matter Section -->
                        <div ref="macrosSection" class="macros-box scroll-animate" data-delay="500">
                            <div class="rep_box-header">Macros Matter</div>
                            <div class="rep_box-sub">Your body burns calories just digesting food. Protein burns the most, then carbs, then fats. Hitting your macro targets keeps you full, protects muscle, and drives fat loss.</div>
                            <div class="boxes-flex">
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Protein</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.protein }}g</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_protein.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Carbs</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.carbs }}g</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_carbs.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Fat</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.fat }}g</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_egg.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="boxes-flex">
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Fiber</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.fiber }}g</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_fiber.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Sugar</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.sugar }}g</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_sugar.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="rep_boxdiv">
                                    <div class="box">
                                        <div class="div-block-2149">
                                            <div class="box_text-side">
                                                <div class="text-block-1568-copy">Water</div>
                                                <div class="text-block-1566">{{ userMetabolics.metabolics.macros.sustainable.water }}oz</div>
                                                <div class="text-block-1568">per day</div>
                                            </div>
                                            <div class="div-block-2151"><img src="@/assets/images/icon_water_1.svg" loading="lazy" alt="" class="image-635"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a href="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/pdf/The_NewSelf_Fat_Loss_Protocol-A_Simpler_Path_to_Results.pdf" target="_blank" class="button-159 w-button">Download Metabolic Weight Loss Guide</a>
                        </div>
                        
                        <!-- Timeline Section -->
                        <div ref="timelineSection" class="timeline-box scroll-animate" data-delay="600">
                            <div class="boxes-flex">
                                <div class="rep_boxdiv"></div>
                                <div class="rep_boxdiv"></div>
                                <div class="rep_boxdiv"></div>
                            </div>
                            <div class="boxes-flex">
                                <div class="rep_boxdiv"></div>
                                <div class="rep_boxdiv"></div>
                                <div class="rep_boxdiv"></div>
                            </div>
                            <div class="rep_box-header">Your Goal Timeline</div>
                            <div class="rep_boxhighlight-header">How Fast Can You Lose the Weight?</div>
                            <div class="rep_box-sub">Everyone's timeline looks different, but it usually comes down to the pace you choose:</div>
                            <div class="timeline-entry aggr">
                                <div class="timeline-type">
                                    <div class="timeline-type-header">Aggressive</div>
                                    <div class="timeline-type-sub">Maximum weight loss in the shortest time. Works, but tough to sustain long-term.</div>
                                </div>
                                <div class="timeline-estimate">
                                    <div class="text-block-1385-copy">{{ userMetabolics.metabolics.goalDates.aggressive?.days || 90 }}<span class="text-span-381">Days</span></div>
                                    <div class="text-block-1382">{{ userMetabolics.metabolics.goalDates.aggressive?.date || '12/12/2025' }}</div>
                                </div>
                            </div>
                            <div class="timeline-entry">
                                <div class="timeline-type">
                                    <div class="timeline-type-header">Accelerated</div>
                                    <div class="timeline-type-sub">The sweet spot: strong, steady progress with moderate effort.</div>
                                </div>
                                <div class="timeline-estimate">
                                    <div class="text-block-1385-copy">{{ userMetabolics.metabolics.goalDates.accelerated?.days || 90 }}<span class="text-span-381">Days</span></div>
                                    <div class="text-block-1382">{{ userMetabolics.metabolics.goalDates.accelerated?.date || '12/12/2025' }}</div>
                                </div>
                            </div>
                            <div class="timeline-entry sustain">
                                <div class="timeline-type">
                                    <div class="timeline-type-header">Sustainable</div>
                                    <div class="timeline-type-sub">Slow and steady. The easiest to stick with - especially on GLPs, where smaller meals and consistency make it feel natural.</div>
                                </div>
                                <div class="timeline-estimate">
                                    <div class="text-block-1385-copy">{{ userMetabolics.metabolics.goalDates.sustainable?.days || 90 }}<span class="text-span-381">Days</span></div>
                                    <div class="text-block-1382">{{ userMetabolics.metabolics.goalDates.sustainable?.date || '12/12/2025' }}</div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- eBook Section -->
                        <div ref="ebookSection" class="rep_ebook-segment scroll-animate" data-delay="700">
                            <div class="report_segment-div ebook">
                                <div class="rep_segment-header ebook">The System + The Shortcut</div>
                                <div class="segment-flex-div">
                                    <div class="segment-flex-left">
                                        <p ref="ebookText" class="rep_segment-sub scroll-animate" data-delay="800">Your 60-page eBook gives you the complete system—the last guide you'll ever need. The Whole Food Macro Summary is the shortcut, showing the simplest foods to hit your targets without the guesswork. Together, they make staying on track simple and sustainable.<br></p>
                                    </div>
                                    <div class="segment-flex-right"><img src="@/assets/images/fatloss_mock01.webp" loading="lazy" sizes="(max-width: 767px) 100vw, 570.9896240234375px" alt=""></div>
                                </div>
                                <a href="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/pdf/The_NewSelf_Fat_Loss_Protocol-A_Simpler_Path_to_Results.pdf" target="_blank" class="button-159 w-button">Access E-Book</a>
                            </div>
                        </div>
                    </div>
                    <!-- Animation div -->
                   
                </div>
            </div>
            <div class="tedee_wrap"></div>
        </section>
        
        <div class="w-layout-blockcontainer container_pagebutton w-container">
            <a href="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/pdf/The_NewSelf_Fat_Loss_Protocol-A_Simpler_Path_to_Results.pdf" target="_blank" class="link-block-93 w-inline-block">
            <div class="text-block-1496">Download Our Free Ebook <span class="text-span-352">-&gt;</span></div>
            <div class="text-block-1497">The NewSelf Fat Loss Protocol</div>
            </a>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    name: 'UserReport',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            isLoading: false,
            hasError: false,
            errorMessage: '',
            quizData: null,
            scrollObserver: null,
            animatedElements: []
        }
    },

    async mounted() {
        await this.loadUserQuizData();
        
        this.$nextTick(() => {
            this.setupScrollAnimations();
        });
    },

    beforeDestroy() {
        this.destroyScrollAnimations();
    },

    computed: {
        ...mapGetters(['user']),
        userMetabolics() {
            if (!this.quizData) {
                return null;
            }

            try {
                return this.calculateUserMetabolics(this.quizData);
            } catch (error) {
                console.error('Error calculating metabolics:', error);
                return null;
            }
        }
    },

    methods: {
        ...mapActions(['fetchUserQuizData']),
        setupScrollAnimations() {
            // Check if Intersection Observer is supported
            if (!window.IntersectionObserver) {
                console.warn('Intersection Observer not supported, animations disabled');
                return;
            }
            const observerOptions = {
                root: null, // viewport
                rootMargin: '0px 0px -50px 0px', // Start animation 50px before element enters viewport
                threshold: 0.1 // Trigger when 10% of element is visible
            };
            this.scrollObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.animateElement(entry.target);
                        // Stop observing this element once it's animated
                        this.scrollObserver.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            this.observeAnimatedElements();
        },

        // Reasoning: Finds and observes all elements that should be animated
        observeAnimatedElements() {
            const elements = this.$el.querySelectorAll('.scroll-animate');

            elements.forEach(element => {
                // Add to our tracking array
                this.animatedElements.push(element);
                // Start observing the element
                this.scrollObserver.observe(element);
            });

            console.log(`Observing ${elements.length} elements for scroll animations`);
        },
        animateElement(element) {
            const delay = element.getAttribute('data-delay') || '0';
            const delayMs = parseInt(delay);
            setTimeout(() => {
                element.classList.add('animate-in');
                element.dispatchEvent(new CustomEvent('animated', {
                    detail: {
                        element
                    }
                }));
            }, delayMs);
        },
        destroyScrollAnimations() {
            if (this.scrollObserver) {
                this.animatedElements.forEach(element => {
                    this.scrollObserver.unobserve(element);
                });
                this.scrollObserver.disconnect();
                this.scrollObserver = null;
            }
            this.animatedElements = [];
        },
        triggerAnimation(elementRef) {
            const element = this.$refs[elementRef];
            if (element) {
                this.animateElement(element);
            }
        },
        resetAnimations() {
            this.animatedElements.forEach(element => {
                element.classList.remove('animate-in');
            });
            this.$nextTick(() => {
                this.destroyScrollAnimations();
                this.setupScrollAnimations();
            });
        },
        async loadUserQuizData() {
            try {
                this.isLoading = true;
                this.hasError = false;
                const response = await this.$axios.get(`${this.baseUrl}/api/user-metadata`);
                if (response.data.status === 'success' && response.data.data) {
                    const userData = response.data.data;
                    const requiredFields = [
                        'height', // Required for BMR calculation
                        'weight', // Required for BMR calculation  
                        'goal_weight', // Required for deficit planning
                        'dob', // Required for age calculation in BMR
                        'activity_level' // Required for TDEE calculation
                    ];
                    const missingFields = [];
                    const blankFields = [];

                    for (const field of requiredFields) {
                        if (!Object.prototype.hasOwnProperty.call(userData, field)) {
                            missingFields.push(field);
                            continue;
                        }
                        
                        const value = userData[field];
                        
                        if (value === null || value === undefined || value === '' ||
                            (typeof value === 'string' && value.trim() === '')) {
                            blankFields.push(field);
                        }
                    }
                    if (missingFields.length > 0 || blankFields.length > 0) {
                        console.warn('Missing required fields:', missingFields);
                        console.warn('Blank required fields:', blankFields);
                        this.$router.push({
                            name: 'tdeeIntakeForm',
                            query: {
                                missing: [...missingFields, ...blankFields].join(','),
                                from: 'UserReport'
                            }
                        });
                        return;
                    }
                    const numericFields = ['height', 'weight', 'goal_weight'];
                    const invalidNumericFields = [];

                    for (const field of numericFields) {
                        const value = parseFloat(userData[field]);
                        if (isNaN(value) || value <= 0) {
                            invalidNumericFields.push(field);
                        }
                    }
                    if (invalidNumericFields.length > 0) {
                        console.warn('Invalid numeric fields:', invalidNumericFields);
                        this.$router.push({
                            name: 'tdeeIntakeForm',
                            query: {
                                invalid: invalidNumericFields.join(','),
                                from: 'UserReport'
                            }
                        });
                        return;
                    }
                    const dobDate = this.parseDateString(userData.dob);
                    if (!dobDate || isNaN(dobDate.getTime())) {
                        console.warn('Invalid date of birth:', userData.dob);
                        this.$router.push({
                            name: 'tdeeIntakeForm',
                            query: {
                                invalid: 'dob',
                                from: 'UserReport'
                            }
                        });
                        return;
                    }
                    const validActivityLevels = [
                        'Sedentary',
                        'Lightly active',
                        'Moderately active',
                        'Very active',
                        'Highly active'
                    ];

                    if (!validActivityLevels.includes(userData.activity_level)) {
                        console.warn('Invalid activity level:', userData.activity_level);
                        this.$router.push({
                            name: 'tdeeIntakeForm',
                            query: {
                                invalid: 'activity_level',
                                from: 'UserReport'
                            }
                        });
                        return;
                    }
                    this.quizData = userData;
                    console.log('Successfully loaded and validated user metadata:', this.quizData);

                } else if (response.data.status === 'error') {
                    console.warn('No user metadata found - redirecting to tdeeIntakeForm');
                    this.$router.push({
                        name: 'tdeeIntakeForm',
                        query: {
                            reason: 'no_data',
                            from: 'UserReport'
                        }
                    });
                    return;
                } else {
                    throw new Error('Unexpected response format from server');
                }

            } catch (error) {
                console.error('Error loading user metadata:', error);
                this.hasError = true;

                if (error.response?.status === 401) {
                    this.errorMessage = 'Please log in to view your report.';
                } else if (error.response?.status === 404) {
                    this.errorMessage = 'Please complete your extended profile first.';
                    setTimeout(() => {
                        this.$router.push({
                            name: 'tdeeIntakeForm'
                        });
                    }, 2000);
                } else {
                    this.errorMessage = 'Unable to load your profile data. Please try again or complete your extended profile.';
                }

                this.quizData = null;
            } finally {
                this.isLoading = false;
            }
        },
        redirectTotdeeIntakeForm(reason = 'manual') {
            this.$router.push({
                name: 'tdeeIntakeForm',
                query: {
                    reason,
                    from: 'UserReport'
                }
            });
        },
        parseDateString(dateString) {
            if (!dateString) return null;

            const parts = dateString.split('/');
            if (parts.length === 3) {
                const month = parseInt(parts[0]) - 1; // Month is 0-indexed
                const day = parseInt(parts[1]);
                const year = parseInt(parts[2]);
                return new Date(year, month, day);
            }

            const parsed = new Date(dateString);
            return isNaN(parsed.getTime()) ? null : parsed;
        },
        calculateAge(dob) {
            if (!dob) return null;

            const today = new Date();
            const birthDate = dob instanceof Date ? dob : new Date(dob);

            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            console.log(`Calculated age: ${age} from DOB:`, birthDate);
            return age;
        },
        calculateBMR(weight, height, age, gender) {
            let heightInInches = height;
            if (typeof height === 'string' && height.includes("'")) {
                const parts = height.split("'");
                heightInInches = (parseInt(parts[0]) * 12) + parseInt(parts[1] || 0);
            }

            const weightInKg = weight / 2.20462;
            const heightInCm = heightInInches * 2.54;

            let bmr;
            if (gender === 'Male') {
                bmr = (10 * weightInKg) + (6.25 * heightInCm) - (5 * age) + 5;
            } else {
                bmr = (10 * weightInKg) + (6.25 * heightInCm) - (5 * age) - 161;
            }

            return Math.round(bmr);
        },
        getActivityMultiplier(activityLevel) {
            const multipliers = {
                'Sedentary': 1.2,
                'Lightly active': 1.375,
                'Moderately active': 1.55,
                'Very active': 1.725,
                'Highly active': 1.9
            };

            return multipliers[activityLevel] || 1.2;
        },
        calculateTDEE(bmr, activityLevel) {
            const multiplier = this.getActivityMultiplier(activityLevel);
            return Math.round(bmr * multiplier);
        },
        calculateCalorieDeficits(tdee, currentWeight, goalWeight) {
            const gender = this.user?.gender || 'Male';
            const minCalories = gender === 'Female' ? 1200 : 1500;
            const caloriesPerPound = 3500;
            const weightToLose = currentWeight - goalWeight;

            const deficitPlans = {
                aggressive: {
                    name: 'Aggressive',
                    percentage: 50,
                    description: '50% Caloric Reduction'
                },
                accelerated: {
                    name: 'Accelerated',
                    percentage: 40,
                    description: '40% Caloric Reduction'
                },
                sustainable: {
                    name: 'Sustainable',
                    percentage: 30,
                    description: '30% Caloric Reduction'
                }
            };

            Object.keys(deficitPlans).forEach(planType => {
                const plan = deficitPlans[planType];
                const targetDeficit = tdee * (plan.percentage / 100);
                const targetCalories = tdee - targetDeficit;

                const safeCalories = Math.max(targetCalories, minCalories);
                const actualDeficit = tdee - safeCalories;
                const actualPercentage = Math.round((actualDeficit / tdee) * 100);

                const lbsPerWeek = (actualDeficit * 7) / caloriesPerPound;
                const weeksToGoal = weightToLose / lbsPerWeek;
                const daysToGoal = Math.round(weeksToGoal * 7);

                plan.dailyCalories = Math.round(safeCalories);
                plan.deficit = Math.round(actualDeficit);
                plan.percentage = actualPercentage; 
                plan.lbsPerWeek = Math.round(lbsPerWeek * 10) / 10;
                plan.weeksToGoal = Math.round(weeksToGoal * 10) / 10;
                plan.daysToGoal = daysToGoal;
            });

            return deficitPlans;
        },
        calculateWeightLossPerWeek(deficits) {
            const projections = {};
            Object.keys(deficits).forEach(type => {
                const deficit = deficits[type];
                projections[type] = {
                    lbsPerWeek: deficit.lbsPerWeek,
                    daysToGoal: deficit.daysToGoal,
                    weeksToGoal: deficit.weeksToGoal,
                    totalIn12Weeks: Math.round(deficit.lbsPerWeek * 12), // Traditional 12-week view
                    totalIn90Days: Math.round(deficit.lbsPerWeek * (90 / 7)), // 90-day progress
                    isRealistic: deficit.daysToGoal <= 730 // Achievable within 2 years
                };
            });

            return projections;
        },
        calculateGoalDates(weightLoss) {
            const today = new Date();

            const goalDates = {};
            Object.keys(weightLoss).forEach(type => {
                const projection = weightLoss[type];
                const goalDate = new Date(today);
                goalDate.setDate(goalDate.getDate() + projection.daysToGoal);

                goalDates[type] = {
                    days: projection.daysToGoal,
                    weeks: projection.weeksToGoal,
                    date: goalDate.toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric'
                    }),
                    message: `${projection.daysToGoal} Days`,
                    achievable: projection.isRealistic,
                    note: projection.daysToGoal > 365 ? 'Long-term goal' : 'Medium-term goal'
                };
            });

            return goalDates;
        },
        calculateMacronutrients(dailyCalories) {
            const proteinCalories = dailyCalories * 0.30;
            const carbCalories = dailyCalories * 0.35;
            const fatCalories = dailyCalories * 0.35;

            return {
                protein: Math.round(proteinCalories / 4), // grams
                carbs: Math.round(carbCalories / 4), // grams
                fat: Math.round(fatCalories / 9), // grams
                fiber: Math.round(dailyCalories / 100), // 1g per 100 calories
                sugar: Math.round(dailyCalories * 0.10 / 4), // Max 10% of calories from added sugar
                water: this.calculateWaterNeeds() // Based on quiz data
            };
        },
        calculateWaterNeeds() {
            if (!this.quizData) return 64; // Default 64 oz

            const weight = parseFloat(this.quizData.weight) || 150;
            let baseWater = weight * 0.75; // 0.75 oz per pound

            const activityLevel = this.quizData.activity_level;
            if (activityLevel === 'Very active' || activityLevel === 'Highly active') {
                baseWater *= 1.2; // 20% more for very active people
            } else if (activityLevel === 'Moderately active') {
                baseWater *= 1.1; // 10% more for moderately active
            }

            return Math.round(baseWater);
        },
        getWaistDisplayInfo(userData) {
            if (userData.waist_type === 'measurement' && userData.waist_measurement) {
                return {
                    type: 'measurement',
                    value: userData.waist_measurement,
                    display: `${userData.waist_measurement} inches`
                };
            } else if (userData.waist_type === 'clothing_size' && userData.clothing_size) {
                return {
                    type: 'clothing_size',
                    value: userData.clothing_size,
                    display: `Size ${userData.clothing_size}`
                };
            }

            return {
                type: 'unknown',
                value: null,
                display: 'Not provided'
            };
        },
        getRecommendedPlan() {
            if (!this.userMetabolics) return 'sustainable';

            const {
                userInfo
            } = this.userMetabolics;
            const weightToLose = userInfo.weightToLose;
            const activityLevel = userInfo.activityLevel;

            if (weightToLose > 30 && (activityLevel === 'Very active' || activityLevel === 'Highly active')) {
                return 'aggressive';
            } else if (weightToLose > 20 || activityLevel === 'Moderately active') {
                return 'accelerated';
            } else {
                return 'sustainable';
            }
        },
        calculateUserMetabolics(userData) {
            try {
                const currentWeight = parseFloat(userData.weight);
                const goalWeight = parseFloat(userData.goal_weight);
                const height = parseFloat(userData.height);
                const dob = this.parseDateString(userData.dob);
                const gender = this.user?.gender || 'Male';
                const activityLevel = userData.activity_level;

                console.log('Processing data:', {
                    currentWeight,
                    goalWeight,
                    height,
                    dob,
                    gender,
                    activityLevel
                });

                // Validation to ensure we have required data
                if (!currentWeight || !goalWeight || !height || !dob || !activityLevel) {
                    console.error('Missing required data:', {
                        currentWeight: !!currentWeight,
                        goalWeight: !!goalWeight,
                        height: !!height,
                        dob: !!dob,
                        activityLevel: !!activityLevel
                    });
                    throw new Error('Missing required user data for calculations');
                }

                const age = this.calculateAge(dob);
                const bmr = this.calculateBMR(currentWeight, height, age, gender);
                const tdee = this.calculateTDEE(bmr, activityLevel);
                const deficits = this.calculateCalorieDeficits(tdee, currentWeight, goalWeight);
                const weightLoss = this.calculateWeightLossPerWeek(deficits);
                const goalDates = this.calculateGoalDates(weightLoss);

                // Calculate macros for each plan
                const macros = {
                    aggressive: this.calculateMacronutrients(deficits.aggressive.dailyCalories),
                    accelerated: this.calculateMacronutrients(deficits.accelerated.dailyCalories),
                    sustainable: this.calculateMacronutrients(deficits.sustainable.dailyCalories)
                };

                // Clear any previous errors since calculation succeeded
                this.hasError = false;
                this.errorMessage = '';

                return {
                    userInfo: {
                        currentWeight,
                        goalWeight,
                        weightToLose: currentWeight - goalWeight,
                        age,
                        activityLevel,
                        waistInfo: this.getWaistDisplayInfo(userData),
                        lifestyle: {
                            dailySteps: userData.daily_steps,
                            weeklyExercise: userData.weekly_exercise,
                            dailyWater: userData.daily_water,
                            sleepHours: userData.sleep_hours
                        }
                    },
                    metabolics: {
                        bmr,
                        tdee,
                        deficits,
                        weightLoss,
                        goalDates,
                        macros
                    }
                };
            } catch (error) {
                console.error('Error in calculateUserMetabolics:', error);
                this.hasError = true;
                this.errorMessage = `Unable to calculate metabolic data: ${error.message}`;
                return null;
            }
        },
        formatNumber(number) {
            if (!number) return '---';
            return number.toLocaleString();
        }
    },

    watch: {
        quizData: {
            handler() {
                if (this.quizData) {
                    this.$nextTick(() => {
                        this.$forceUpdate();
                        this.destroyScrollAnimations();
                        this.setupScrollAnimations();
                    });
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.tedee-image-mobile{
    display: none;
}
@media screen and (max-width: 479px) {
    .macros-box  {
        margin-top: 30px;
    }
    .tedee-image-mobile{
        display: block;
    }
}

.macros-box {
        margin-top: 50px;
    }

.loading-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-text {
    font-size: 16px;
    color: #666;
}

.error-section {
    padding: 20px;
    background-color: #ffe6e6;
    border: 1px solid #ff9999;
    border-radius: 8px;
    margin: 20px;
}

.error-message {
    color: #d32f2f;
    font-weight: 500;
}

/* scroll-animations.css */

/* Base styles for elements that will animate on scroll */
.scroll-animate {
    opacity: 0;
    transform: translateX(-50px);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: opacity, transform;
}

/* Animated state - when element is visible */
.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Different animation types - all now slide from left */
.scroll-animate[data-animation="fade"] {
    transform: translateX(-30px);
}

.scroll-animate[data-animation="fade"].animate-in {
    opacity: 1;
    transform: translateX(0);
}

.scroll-animate[data-animation="slideLeft"] {
    transform: translateX(-50px);
}

.scroll-animate[data-animation="slideLeft"].animate-in {
    opacity: 1;
    transform: translateX(0);
}

.scroll-animate[data-animation="slideRight"] {
    transform: translateX(-50px);
}

.scroll-animate[data-animation="slideRight"].animate-in {
    opacity: 1;
    transform: translateX(0);
}

.scroll-animate[data-animation="slideUp"] {
    transform: translateX(-40px);
}

.scroll-animate[data-animation="slideUp"].animate-in {
    opacity: 1;
    transform: translateX(0);
}

.scroll-animate[data-animation="slideDown"] {
    transform: translateX(-40px);
}

.scroll-animate[data-animation="slideDown"].animate-in {
    opacity: 1;
    transform: translateX(0);
}

.scroll-animate[data-animation="scale"] {
    transform: translateX(-30px) scale(0.95);
}

.scroll-animate[data-animation="scale"].animate-in {
    opacity: 1;
    transform: translateX(0) scale(1);
}

/* Hero section specific animations */
.report-hero .scroll-animate {
    opacity: 0;
    transform: translateX(-60px);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.report-hero .scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Calorie count section animations */
.calorie-count .scroll-animate {
    opacity: 0;
    transform: translateX(-40px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.calorie-count .scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Metabolic boxes animation */
.div-block-2038.scroll-animate {
    opacity: 0;
    transform: translateX(-35px) scale(0.98);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.div-block-2038.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0) scale(1);
}

/* Weight loss section animation */
.rs_right.scroll-animate {
    opacity: 0;
    transform: translateX(-45px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.rs_right.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Macronutrient boxes staggered animation */
.rep_boxdiv.scroll-animate {
    opacity: 0;
    transform: translateX(-35px) scale(0.95);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.rep_boxdiv.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0) scale(1);
}

/* TDEE section animations */
.tedee-section .scroll-animate {
    opacity: 0;
    transform: translateX(-40px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tedee-section .scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Special animations for specific elements */
.tedee-left-div.scroll-animate {
    opacity: 0;
    transform: translateX(-50px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tedee-left-div.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

.tedee-right.scroll-animate {
    opacity: 0;
    transform: translateX(-40px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tedee-right.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Loading states to prevent flash of unstyled content */
.scroll-animate:not(.animate-in) {
    opacity: 0;
}

/* Reduced motion support for accessibility */
@media (prefers-reduced-motion: reduce) {
    .scroll-animate {
        transition: opacity 0.3s ease;
        transform: none !important;
    }

    .scroll-animate.animate-in {
        opacity: 1;
        transform: none !important;
    }
}

/* Performance optimizations */
.scroll-animate {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    perspective: 1000px;
}

/* Ensure smooth scrolling performance */
.scroll-animate.animate-in {
    will-change: auto;
}

/* Container-specific animations */
._6-boxes-div.scroll-animate {
    opacity: 0;
    transform: translateX(-50px);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

._6-boxes-div.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}

/* Weight summary animation */
.weight-summary.scroll-animate {
    opacity: 0;
    transform: translateX(-30px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.weight-summary.scroll-animate.animate-in {
    opacity: 1;
    transform: translateX(0);
}
</style>
